import { useActions, useAppState } from "state";
import { ExtensionFragment, Extensions_Insert_Input } from "state/gql/_types";
import FormSchema, { TenantCreateFragment } from "../schemas/extension-create";
import { addDays } from "utils/dates";
import React from "react";
import FormDrawer from "components/forms/FormDrawer";

type FormPayloadType = TenantCreateFragment

let initialState: FormPayloadType = {
    "end_date": '',
    "start_date": '',
    "rental_period": 0,
    "day_rate": 0,
    "discount": 0,
    "mile_rate": 0,
    "sales_tax": 0.07,
    "order_total": 0,
    "sub_total": 0,
    "deposit": 0,
    "other_fees": 0,
    "end_time": '12:00:00',
    "start_time": '12:00:00',
    "memo": ''
};

export const CreateExtensionDrawer: React.FC<{onClose():void}> = ({ onClose }) => {

    const { createItem, updateItem, deleteItem } = useActions().extensions;
    const { loading, errors } = useAppState().extensions;
    const { currentItem: currentOrder } = useAppState().orders;
    
    let currentItemId = null;
    let currentItemData: FormPayloadType | null = null;
    if (currentOrder) {
        initialState = {
            ...initialState,
            start_date: currentOrder.end_date,
            start_time: currentOrder.start_time,
            end_date: addDays(currentOrder.end_date, 1),
            end_time: currentOrder.start_time,
            day_rate: currentOrder.day_rate,
            mile_rate: currentOrder.mile_rate,
        }
    }

    if (!currentOrder) return null

    const handleCreate = (payload: Extensions_Insert_Input) => {
        return createItem({ ...payload, order_id: currentOrder.id })
    }

    return (
        <>
            <FormDrawer<FormPayloadType, ExtensionFragment, string>
                autoOpen={false}
                formSchema={FormSchema}
                validators={{}}
                createAction={handleCreate}
                updateAction={updateItem}
                deleteAction={deleteItem}
                isLoading={loading}
                errors={errors}
                currentItemId={currentItemId}
                initialData={initialState}
                currentItemData={currentItemData}
                onClose={onClose}
                deleteRedirect={true}
            />

        </>
    )

}